export default __webpack_public_path__ + "static/media/handled-navigator.e7aa44d9.png";